export default __webpack_public_path__ + "locales/si/Settings.json?hash=72b12ef876bdce7c213d0dba6befda55";